<div>
  <div class="modal-header">
    <h4> {{title}} </h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body"> {{message}} </div>
</div>
